import { useState, useEffect } from 'react';
import { whatsNewItems } from './whatsNewConfig';
import { useAuthUser } from '@tenant/utility/AuthHooks';

const WHATS_NEW_SESSION_KEY = 'whatsNewModalShown';

/**
 * Custom hook to manage automatic display of WhatsNew modal
 * Shows the modal once per session when the user first enters the site
 * Only activates for authenticated users
 */
const useWhatsNewAutoShow = () => {
  const [shouldShowAuto, setShouldShowAuto] = useState(false);
  const [hasBeenShownThisSession, setHasBeenShownThisSession] = useState(false);
  const { isAuthenticated } = useAuthUser();

  useEffect(() => {
    // Only proceed if user is authenticated
    if (!isAuthenticated) {
      return;
    }

    // Check if modal has already been shown this session
    const shownThisSession = sessionStorage.getItem(WHATS_NEW_SESSION_KEY);
    
    if (!shownThisSession && whatsNewItems.length > 0) {
      // Small delay to ensure the app is fully loaded and user is properly authenticated
      const timer = setTimeout(() => {
        setShouldShowAuto(true);
      }, 2000); // Increased delay to ensure proper authentication

      return () => clearTimeout(timer);
    } else {
      setHasBeenShownThisSession(true);
    }
  }, [isAuthenticated]);

  const markAsShown = () => {
    sessionStorage.setItem(WHATS_NEW_SESSION_KEY, 'true');
    setShouldShowAuto(false);
    setHasBeenShownThisSession(true);
  };

  const resetAutoShow = () => {
    sessionStorage.removeItem(WHATS_NEW_SESSION_KEY);
    setHasBeenShownThisSession(false);
  };

  return {
    shouldShowAuto: isAuthenticated && shouldShowAuto,
    hasBeenShownThisSession,
    markAsShown,
    resetAutoShow
  };
};

export default useWhatsNewAutoShow;
